import { EnumUserRole, User } from './graphql';

export function isAdmin(user: User) {
  return user?.role === EnumUserRole.Admin;
}

export function isProcessor(user: User) {
  return (
    user?.role === EnumUserRole.Admin || user?.role === EnumUserRole.Vendor
  );
}

export function isProducer(user: User) {
  return user?.role === EnumUserRole.Basic;
}
